import { render, staticRenderFns } from "./uploadCourses.vue?vue&type=template&id=027f36ec&scoped=true"
import script from "./uploadCourses.vue?vue&type=script&lang=js"
export * from "./uploadCourses.vue?vue&type=script&lang=js"
import style0 from "./uploadCourses.vue?vue&type=style&index=0&id=027f36ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f36ec",
  null
  
)

export default component.exports